import React from 'react';
import { useGetFinancialsQuery } from "../../../services/BBFinanceAPI";
import Spinner from '../../utils/Spinner';
import './StockDetails.css';
import StockIncome from './StockIncome';
import StockBalance from './StockBalance';
import StockCash from './StockCash';
import Income from '../../../assets/Finance_Info/Income_Statement.svg';
import Balance from '../../../assets/Finance_Info/Balance_Sheet.svg';
import Cash from '../../../assets/Finance_Info/Cash_Flow.svg';


const StockFinancials = ({ticker}) => {
    const {data: finance, isFetching} = useGetFinancialsQuery(ticker); 
    console.log(finance);
    const incomeData = finance?.result[0];
    const balanceSheet = finance?.result[1];
    const cashFlow = finance?.result[2];

    const financialInfo = [
        {
         title: "Income Statement",
         description: "An income statement or profit and loss account(also referred to as a profit and loss statement (P&L), statement of profit or loss, revenue statement, statement of financial performance, earnings statement, statement of earnings, operating statement, or statement of operations) is one of the financial statements of a company and shows the company's revenues and expenses during a particular period.",
         image: Income
        },
        {
            title: "Balance Sheet",
            description: "A balance sheet outlines a company's assets, liabilities and shareholders' equity at a given point in time. It's a snapshot of what a company owns and owes, and the amount invested by shareholders. The balancing principle is Assets = Liabilities + Shareholders' equity",
            image: Balance
        },
        {
            title: "Cash Flow",
            description: "A cash-flow statement is a report of the company's cash management, which summarises all cash inflows that the company receives from its operations and investment sources, as well as cash outflows involved in the functioning of the business and investments, if any, by the company",
            image: Cash
        }
    ]
    return (
        <div>
            {
                isFetching 
                ? <Spinner />
                : (
                   <div className="w-100 mt-5">
                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item mx-2" role="presentation">
                                <button className="nav-link btn-sm finance-link active" id="pills-income-tab" data-bs-toggle="pill" data-bs-target="#pills-income" type="button" role="tab" aria-controls="pills-income" aria-selected="true">
                                    <small>Income Statement</small>
                                </button>
                            </li>
                            <li className="nav-item mx-2" role="presentation">
                                <button className="nav-link btn-sm finance-link" id="pills-balance-tab" data-bs-toggle="pill" data-bs-target="#pills-balance" type="button" role="tab" aria-controls="pills-balance" aria-selected="false">
                                    <small>Balance Sheet</small>
                                </button>
                            </li>
                            <li className="nav-item mx-2" role="presentation">
                                <button className="nav-link btn-sm finance-link" id="pills-cash-tab" data-bs-toggle="pill" data-bs-target="#pills-cash" type="button" role="tab" aria-controls="pills-cash" aria-selected="false">
                                    <small>Cash Flow</small>
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-income" role="tabpanel" aria-labelledby="pills-income-tab">
                                <StockIncome income={incomeData} aspect={financialInfo[0]}/>
                            </div>
                            <div className="tab-pane fade" id="pills-balance" role="tabpanel" aria-labelledby="pills-balance-tab">
                               <StockBalance balanceSheet={balanceSheet} aspect={financialInfo[1]}/>
                            </div>
                            <div className="tab-pane fade" id="pills-cash" role="tabpanel" aria-labelledby="pills-cash-tab">
                               <StockCash cashFlow={cashFlow} aspect={financialInfo[2]}/>
                            </div>
                        </div>
                   </div>
                  )
            }
        </div>
    )
}

export default StockFinancials
